import React, {PropTypes} from "react"
import styles from "./FilterInput.scss"

import i18n from 'lib/i18n'
const _ = i18n()

const FilterInput = ({filter, setFilter, placeholder}) => (
	<div className={styles.searchContainer}>
		<div className={styles.searchContent}>
			<div className={`${styles.searchLogo} ${styles.search}`}></div>
			<input
				placeholder={placeholder || _('filter')}
				value={filter}
				onChange={ev => setFilter(ev.target.value)}
			/>
			{filter && <div onClick={() => setFilter()} className={styles.removeFilter}>
				<span className={styles.cross}>&times;</span>
			</div>}
		</div>
	</div>
)
FilterInput.propTypes = {
	filter: PropTypes.string,
	setFilter: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
}

export default FilterInput



// WEBPACK FOOTER //
// ./elements/FilterInput.jsx